// extracted by mini-css-extract-plugin
export var closeButton = "_2q-3";
export var header = "_2q-0";
export var link = "_2q-1";
export var retryButton = "_2q-2";